import moment from "moment";
import React, { useState } from "react";
import { PIFlowLeftNavBar } from "../ReusableComp/NavBarLeft";
import NavigationBar from "../ReusableComp/NavigationBar";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
    base_url,
    SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT,
    SUBJECT_STATUS_ON_STUDY,
    SUBJECT_STATUS_OFF_STUDY,
    EVENT_CLASSIFICATION_AESI,
    EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
    EVENT_CLASSIFICATION_GRADE_CTCAE,
    EVENT_CLASSIFICATION_OTHER
} from "../../utilities";
import axios from "../../axios-interceptor";
import PopUpModal from "../ReusableComp/PopUpModal";
import {
    getEventDetails,
    getSAdvEvents,
    getStudyAeDetailsSimplified,
    getAllCausalities,
    getAllOutComes,
    getActionTaken,
    getActionTakenForAE,
} from '../../Redux/actions/actions';
import { useEffect } from "react";
import { useLocation } from 'react-router';
import Loader from '../ReusableComp/Loader'; // Import the Loader component
import BrightonCase from '../PI/SubjectFlow/BrightonCase';
import GradeCase from '../PI/SubjectFlow/GradeCase';
import { FaEye, FaDownload, FaTimes } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';

const ViewAEDetails = () => {
    const navigate = useNavigate()
    const eventDtls = useSelector((state) => state.eventDtls)
    const subjDetails = useSelector((state) => state.getSubProf)
    const causalities = useSelector((state) => state.getCausalities);
    const outComes = useSelector((state) => state.getOutComes);
    const actnTakenOpts = useSelector((state) => state.actionTaken);
    const actionTakenforAe = useSelector((state) => state.actionTakenforAe);
    const saEvents = useSelector((state) => state.getSAEvents);
    const getStudyAeDtls = useSelector((state) => state.getStudyAeDtls)
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const JustBtwn = "d-flex justify-content-between";
    const [searchTerm, setSearchTerm] = useState("");
    const [btnTitle, setBtnTitle] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [seriousAE, setSeriousAE] = useState({});
    const [notesChange, setNotesChange] = useState("");
    const [radioValue, setRadioValue] = useState("")
    const [radioReset, setRadioReset] = useState('')
    const [eventDesc, setEventDesc] = useState()
    const [treatmentGiven, setTreatmentGiven] = useState("")
    const [valuForDisble, setValuForDisble] = useState()
    const [defaultValues, setDefaultValues] = useState({})
    const [selectedDocument, setSelectedDocument] = useState(null);
    let extensions=""

    function removeHtmlTags(input) {
        const regex = /<[^>]+>|&nbsp;/g;
        return input?.replace(regex, '');
    }

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                dispatch(getEventDetails({ adverse_event_id: location.state.adverse_event_mapping_id }))
                dispatch(getSAdvEvents())
                dispatch(getAllCausalities())
                dispatch(getAllOutComes())
                dispatch(getActionTaken())
                dispatch(getActionTakenForAE())
            } catch (error) {
                console.log(error)
            }
        };
        fetchData()
    }, [dispatch]);

    useEffect(() => {
        if (eventDtls) {
            dispatch(getStudyAeDetailsSimplified({
                case_def: eventDtls?.study_case_definition,
                value: eventDtls?.study_aebank_id
            }));
            setDefaultValues({
                dateOfOnset: eventDtls?.date_of_onset,
                dateOfResolution: eventDtls?.date_of_resolution,
                timeOfOnset: eventDtls?.time_of_onset,
                timeOfResolution: eventDtls?.time_of_resolution,
                causality_id: eventDtls?.causality_id,
                outcome_id: eventDtls?.outcome_id,
                action_taken_for_adverse_event_id: eventDtls?.action_taken_for_adverse_event_id,
                action_taken_id: eventDtls?.action_taken_id
            });
            setNotesChange(eventDtls?.input_notes_aesi_others);
            setRadioValue(eventDtls?.event_description_id);
            setLoading(false);
        }

    }, [eventDtls])
    const [open, setOpen] = React.useState(false);
    const minDateofOnset = subjDetails && subjDetails["SubjectDoses.date_of_administration"]
    const [today, setToday] = useState('');

    useEffect(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toDateString();
        setToday(formattedDate);
    }, [today]);
    
    let status = `${subjDetails['SubjectDoses.status']}`
    const myArray = [
        {
            title: subjDetails && subjDetails['Study.study_name'],
            description: "Study",
        },
        {
            description: "Dose",
            title: subjDetails && `D${subjDetails['SubjectDoses.dose']}`,
        },
        {
            title: subjDetails && subjDetails['PrincipalInvestigator.name'],
            description: "Principal Investigator",
        },
        {
            id: 4, description: "Status", title:
                status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
                    status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
                        status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
        }
    ];

    const getRoleCode = (data) => { };

    const handleBack = () => {
        navigate('/marketingstaffsubjectlist', {
            state: {
                data: 2,
            }
        })
    }

    const handleTreatment=(e)=>{
        let value = e.target.value;
         if(value!==''){ setTreatmentGiven(value)}
         else{setTreatmentGiven('')}
         
    }

    const handleDefaultValuesChange = e => {
        const { name, value } = e.target;
        setDefaultValues(prev => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleNotesChange = (e) => {
        setNotesChange(e.target.value)
    }

    const handleReset = () => {
        setRadioReset('')
    }

    function getEventDescId(val) {
        if (val) {
            setEventDesc(val)
            setValuForDisble(val)
        }
    }

    function handleRadioBtn(val) {
        setRadioValue(val)
    }

    function handleConfirm() {
        window.location.replace("/pisubjectslist")
    }

    const handleClosePopup = () => {
        setOpen(false);
        window.location.reload();
    };

    function handleSearch(e) {
        setSearchTerm(e.target.value);
    }

    function handleOption(e) {
        setSearchTerm(e.serious_adverse_event_name);
        setShowPopup(false)
        setBtnTitle(e.serious_adverse_event_name)
        setSeriousAE({
            label: e.serious_adverse_event_name,
            value: e.serious_adverse_event_id,
        })
    }

    function handleDropDown() {
        setShowPopup(!showPopup)
        setSearchTerm('');

    }

    const handleUpdate = () => {
        let updateObj = {
            "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id,
            "date_of_onset": defaultValues.dateOfOnset,
            "time_of_onset": defaultValues.timeOfOnset,
            "date_of_resolution": defaultValues.dateOfResolution,
            "time_of_resolution": defaultValues.timeOfResolution,
            "causality_id": defaultValues.causality_id,
            "outcome_id": defaultValues.outcome_id,
            "action_taken_id": defaultValues.action_taken_id,
            "action_taken_for_adverse_event_id": defaultValues.action_taken_for_adverse_event_id,
            "event_description_id": eventDesc && eventDesc.event_description_id,
            "is_case_meets":eventDesc && eventDesc.is_case_meets,
            "any_treatment_given": treatmentGiven,
            "input_notes_aesi_others": notesChange,
            "serious_adverse_event_id": seriousAE.value,
            "updated_by": localStorage.login_user_name
        }
        axios
            .post(base_url + "principal-investigator/update_adverse_event", updateObj)
            .then((res) => {
                if (res.data.data.errors) {
                    if (res.data.data.errors[0].message) {
                        toast.error(`${res.data.data.errors[0].message}`, {
                            toastId: 2
                        })
                    }
                }
                else {
                    setOpen(true);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const cleanText =
        eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ? eventDtls?.input_notes_aesi_others :
            eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? eventDtls?.study_event_meets_case_definition || eventDtls.study_event_doesnt_meets_case_definition :
                eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? eventDtls?.study_ctcae_definition :
                    eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER ? eventDtls?.input_notes_aesi_others : ''
        ;

        const handleViewClick = (document) => {
            setSelectedDocument(document);
          };
        
          function getIcon(fileExtension) {
            switch (fileExtension) {
              case 'pdf':
                return "./images/icons/reshot-icon-pdf.svg"
              case 'ppt':
                return "./images/icons/reshot-icon-ppt.svg"
              case 'txt':
                return "./images/icons/reshot-icon-txt.svg"
              case 'docx':
                return "./images/icons/reshot-icon-docx.svg"
              case 'doc':
                return "./images/icons/reshot-icon-doc.svg"
              case 'xls':
                return "./images/icons/reshot-icon-xls.svg"
              case 'csv':
                return "./images/icons/reshot-icon-csv.svg"
              case 'jpg':
                return "./images/icons/reshot-icon-jpg.svg"
              case 'png':
                return "./images/icons/reshot-icon-png.svg"
              case 'jpeg':
                return "./images/icons/reshot-icon-jpeg.svg"
             }
          }
          const handleOpenModal = (document) => {
            setSelectedDocument(document);
          };
        
          const handleCloseModal = () => {
            setSelectedDocument(null);
          };
          const isImage = (url) => {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
            return imageExtensions.includes(url);
          };    


          const [timeError, setTimeError] = useState("");
  const [showTimeError, setShowTimeError] = useState(false)

  function validateTimeOfResolution(event) {
    const inputTime = event.target.value;
    const timeOfOnset = defaultValues.timeOfOnset;
  
    if (timeOfOnset) {
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+defaultValues.timeOfOnset
        setTimeError(val)
        setShowTimeError(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError("val")
        setShowTimeError(false)
      }
    }
  }
  
  
  function timeStringToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }
         
    return (
        <>
            <div>
                <NavigationBar studyDropdwn={true}
                    title={'Update Adverse Event'}
                    rolecode={getRoleCode}
                />
                {/* <PIFlowLeftNavBar /> */}
                <div className="main_body ">
                    <Container fluid className="p-3 page_two_styl">
                        <Row className="SVdtl_Main">
                            <Col lg={4} className="section_1">
                                {subjDetails && <div className="pisubj_left_main">
                                    <div className="review_min_high">
                                        <div className="body_cls pb-2">
                                            <h6 className="mb-0">
                                                {subjDetails?.first_name}
                                                {" " + subjDetails?.last_name}
                                            </h6>

                                            <span>

                                                <h6>{subjDetails?.subject_code}</h6>

                                                <p className="mb-0">
                                                    {subjDetails?.age} Yrs
                                                </p>
                                            </span>

                                            <span className="d-flex justify-content-between w-100">

                                                <h6 className="site_add">
                                                    {subjDetails['Site.site_address']}
                                                </h6>
                                                <img
                                                    className=""
                                                    src="./images/icons/location.svg"
                                                    alt="Location Icon"
                                                />
                                            </span>
                                        </div>
                                        <div className="px-3 s2">
                                            {myArray.map((i, index) => {
                                                return (
                                                    <div className="studytab" key={index}>
                                                        <span className="text-start">{i.title}</span>
                                                        <span className="study_tab_desc">
                                                            {i.description}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>}
                            </Col>

                            <div className="col review_event_header pisub">
                                <div className='title_cls right_cntnt'>
                                    <h5 className="mb-1">Event</h5>
                                </div>

                                <Col className="px-4 py-3 qr_right_content">
                                    <div className="d-flex justify-content-between ">

                                        <div className="">
                                            <label htmlFor="dateOfonSet" className="custm_label_fw">
                                                Date of onset
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                value={defaultValues.dateOfOnset}
                                                className="customInput"
                                                id="dateOfOnset"
                                                type="date"
                                                name="dateOfOnset"
                                                min={minDateofOnset}
                                                max={moment(today).format("YYYY-MM-DD")}
                                                placeholder="Enter Here"
                                                aria-placeholder="#D4D4D4"
                                                style={{
                                                    padding: "16px 12px",
                                                    width: "340px",
                                                    cursor: "not-allowed",
                                                }}
                                                onChange={handleDefaultValuesChange}
                                                onKeyDown={(e) => e.preventDefault()}
                                            />
                                            {defaultValues.dateOfOnset?null:
                                                    <span className="placeholder-span">dd-mm-yyyy</span>
                                                    }
                                        </div>

                                        <div className="">
                                            <label htmlFor="timeOfonSet" className="custm_label_fw">
                                                Time of onset (24 Hrs)
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                value={defaultValues.timeOfOnset}
                                                className="customInput"
                                                id="timeOfOnset"
                                                type="time"
                                                name="timeOfOnset"
                                                placeholder="Enter Here"
                                                aria-placeholder="#D4D4D4"
                                                style={{ padding: "16px 12px", width: "340px" }}
                                                onChange={handleDefaultValuesChange}
                                            />
                                            {defaultValues.timeOfOnset?null:
                                                    <span className="placeholder-span">--:--</span>
                                                    }
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between ">
                                        <div className="">
                                            <label
                                                htmlFor="dateOfResolution"
                                                className="custm_label_fw"
                                            >
                                                Date of resolution
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                value={defaultValues.dateOfResolution}
                                                className="customInput"
                                                id="dateOfResolution"
                                                name="dateOfResolution"
                                                min={defaultValues.dateOfOnset}
                                                max={moment(today).format("YYYY-MM-DD")}
                                                type="date"
                                                placeholder="Enter Here"
                                                aria-placeholder="#D4D4D4"
                                                style={{
                                                    padding: "16px 12px",
                                                    width: "340px",
                                                    cursor: "not-allowed",
                                                }}
                                                onKeyDown={(e) => e.preventDefault()}
                                                onChange={handleDefaultValuesChange}
                                            />
                                            {defaultValues.dateOfResolution?null:
                                                    <span className="placeholder-span">dd-mm-yyyy</span>
                                                    }
                                        </div>
                                        {
                                            defaultValues.dateOfOnset === defaultValues.dateOfResolution ?
                                            <div className="">
                                            <label htmlFor="lastName" className="custm_label_fw">
                                                Time of resolution (24 Hrs)
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                value={defaultValues.timeOfResolution}
                                                className="customInput"
                                                id="timeOfResolution"
                                                name="timeOfResolution"
                                                type="time"
                                                placeholder="Enter Here"
                                                aria-placeholder="#D4D4D4"
                                                style={{ padding: "16px 12px", width: "340px" }}
                                                onChange={handleDefaultValuesChange}
                                                min={defaultValues.timeOfOnset}
                                                onInput={validateTimeOfResolution}
                                            />
                                            {defaultValues.timeOfResolution?null:
                                                    <span className="placeholder-span">--:--</span>
                                                    }
                                            <span style={{color:"red", fontSize:"14px"}}>
                                                {showTimeError? timeError : null}
                                            </span>
                                        </div>
                                        :
                                        <div className="">
                                            <label htmlFor="lastName" className="custm_label_fw">
                                                Time of resolution (24 Hrs)
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                value={defaultValues.timeOfResolution}
                                                className="customInput"
                                                id="timeOfResolution"
                                                name="timeOfResolution"
                                                type="time"
                                                placeholder="Enter Here"
                                                aria-placeholder="#D4D4D4"
                                                style={{ padding: "16px 12px", width: "340px" }}
                                                onChange={handleDefaultValuesChange}
                                            />
                                            {defaultValues.timeOfResolution?null:
                                                    <span className="placeholder-span">--:--</span>
                                                    }
                                        </div>
                                        }
                                        
                                    </div>
                                    <div className={` gap-2 border p-3 rounded`}>
                                        <div className="d-flex flex-column gap-3">
                                            <div className={`d-flex ${JustBtwn}`}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <label htmlFor="causality">
                                                        Causality
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        value={defaultValues.causality_id}
                                                        className="selectTag"
                                                        id="lastName"
                                                        type="text"
                                                        name='causality_id'
                                                        style={{ padding: "16px 12px", width: "340px" }}
                                                        onChange={handleDefaultValuesChange}
                                                    >
                                                        <option value={"Select"}>{eventDtls?.causality_name}</option>
                                                        {causalities &&
                                                            causalities.map((i) => {
                                                                return (
                                                                    <option
                                                                        key={i.causality_id}
                                                                        value={i.causality_id}
                                                                    >
                                                                        {i.causality_name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <label htmlFor="outCome">
                                                        Outcome
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        value={defaultValues.outcome_id}
                                                        className="selectTag"
                                                        id="lastName"
                                                        type="text"
                                                        name='outcome_id'
                                                        style={{ padding: "16px 12px", width: "340px" }}
                                                        onChange={handleDefaultValuesChange}
                                                    >
                                                        <option value={"Select"}>
                                                            {eventDtls?.outcome_name}
                                                        </option>
                                                        {outComes &&
                                                            outComes.map((i) => {
                                                                return (
                                                                    <option value={i.outcome_id} key={i.outcome_id}>
                                                                        {i.outcome_name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>

                                            </div>
                                            <div className={`d-flex ${JustBtwn}`}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <label htmlFor="actionTaken">
                                                        Action Taken For Study Vaccine
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        value={defaultValues.action_taken_id}
                                                        className="selectTag"
                                                        id="lastName"
                                                        type="text"
                                                        name='action_taken_id'
                                                        style={{ padding: "16px 12px", width: "340px" }}
                                                        onChange={handleDefaultValuesChange}
                                                    >
                                                        <option value={"Select"}>{eventDtls?.action_taken_name}</option>
                                                        {actnTakenOpts &&
                                                            actnTakenOpts.map((i) => {
                                                                return (
                                                                    <option
                                                                        key={i.action_taken_id}
                                                                        value={i.action_taken_id}
                                                                    >
                                                                        {i.action_taken_name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <label htmlFor="actionTaken">
                                                        Action Taken For Adverse Event
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        value={defaultValues.action_taken_for_adverse_event_id}
                                                        className="selectTag"
                                                        id="lastName"
                                                        type="text"
                                                        name='action_taken_for_adverse_event_id'
                                                        style={{ padding: "16px 12px", width: "340px" }}
                                                        onChange={handleDefaultValuesChange}
                                                    >
                                                        <option value={"Select"}>
                                                            {eventDtls?.action_taken_for_adverse_event_name}
                                                        </option>
                                                        {actionTakenforAe &&
                                                            actionTakenforAe.map((i) => {
                                                                return (
                                                                    <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                                                        {i.action_taken_for_adverse_event_name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* <div htmlFor="lastName" className="custm_label_fw">
                                Past Health History
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <label htmlFor="lastName" className="">
                                        Allergies
                                    </label>
                                    <input
                                        value={eventDtls?.allergies ? eventDtls.allergies : '-'}
                                        className="customInput"
                                        id="lastName"
                                        type="text"
                                        aria-placeholder="#D4D4D4"
                                        style={{ padding: "16px 12px", width: "340px" }}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="lastName" className="">
                                        Medication used in the last 3 weeks
                                    </label>
                                    <input
                                        value={eventDtls?.allergies ? eventDtls.allergies : '-'}
                                        className="customInput"
                                        id="lastName"
                                        type="text"
                                        aria-placeholder="#D4D4D4"
                                        style={{ padding: "16px 12px", width: "340px" }}
                                    />
                                </div>

                            </div>

                            <div className="d-flex justify-content-between">
                                <div>
                                    <label htmlFor="lastName" className="">
                                        Concurrent Illness
                                    </label>
                                    <input
                                        value={eventDtls?.concurrent_illness ? eventDtls.concurrent_illness : '-'}
                                        className="customInput"
                                        id="lastName"
                                        type="text"
                                        aria-placeholder="#D4D4D4"
                                        style={{ padding: "16px 12px", width: "340px" }}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="medical_history" className="">
                                        Family History
                                    </label>
                                    <input
                                        value={eventDtls?.medical_history ? eventDtls.medical_history : '-'}
                                        className="customInput"
                                        id="medical_history"
                                        type="text"
                                        aria-placeholder="#D4D4D4"
                                        style={{ padding: "16px 12px", width: "340px" }}
                                    />
                                </div>
                            </div> */}
                                    {eventDtls?.serious_adverse_event_name ?
                                        <Row className="d-flex align-items-center">

                                            <Col>
                                                <label htmlFor="lastName">
                                                    Serious adverse event criteria
                                                </label>
                                            </Col>
                                            <Col>
                                                <span>
                                                    <button className="red_btn advesre-serious" > {eventDtls?.serious_adverse_event_name}</button>
                                                </span>
                                            </Col>
                                        </Row>

                                        :
                                        <div className="text-start d-flex flex-column justify-content-between">
                                            <Row>
                                                <div className="d-flex justify-content-between my-2">
                                                    <Col><label htmlFor="search_block">Serious Adverse Criteria<span className="text-danger">*</span></label></Col>
                                                    <Col>
                                                        <div className="search_block" id='search_block' >
                                                            <div className="orange_btn" onClick={handleDropDown} style={{ width: "350px", padding: "12px 14px" }}
                                                            > {btnTitle.length > 30 ? btnTitle.slice(0, 30) + "..." : btnTitle || 'Select Adverse Criteria'}
                                                                <img src="./images/icons/selectarrow.svg" alt="" />
                                                            </div>
                                                            {showPopup && <div className="search_main" onBlur={() => {
                                                                setTimeout(() => {
                                                                    if (showPopup) {
                                                                        setShowPopup(false)
                                                                    }
                                                                }, 200)
                                                            }}>
                                                                <div className='drop_down_for_search'>
                                                                    <input
                                                                        type="text"
                                                                        autoFocus
                                                                        value={searchTerm}
                                                                        onChange={handleSearch}
                                                                        placeholder="Search..."
                                                                    />
                                                                    <img className='sasd' src="./images/icons/search.svg" alt="" />
                                                                    <div className="eventlist_items">
                                                                        {saEvents &&
                                                                            saEvents.filter(i => {
                                                                                const event = i.serious_adverse_event_name || '';
                                                                                return event.toLowerCase().includes((searchTerm || '').toLowerCase())
                                                                            }).map((i, index) => {

                                                                                return (
                                                                                    <ul className='aelistdropdown' key={index}>
                                                                                        <li className={`${i.serious_adverse_event_name === btnTitle ? 'selectedOption' : ''}`} onClick={() => handleOption(i)}
                                                                                        >{i.serious_adverse_event_name || 'Select Adverse Criteria'}</li>
                                                                                    </ul>
                                                                                )
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </Col>
                                                </div>
                                            </Row>
                                        </div>
                                    }
                                    {eventDtls?.study_aebank_event_title !== null && <Row className="d-flex align-items-center">
                                        <Col>
                                            <label htmlFor="lastName">
                                                Adverse event
                                            </label>
                                        </Col>
                                        <Col>
                                            <span>
                                                <button className="orange_btn advesre-serious" > {eventDtls?.study_aebank_event_title}</button>
                                            </span>
                                        </Col>
                                    </Row>}
                                    <div className="advEventGroup">
                                        <div className="p-4 bg-light rounded eventClassificationDiv">
                                            <div className="custm-radio-styl reviewlist">
                                                {((eventDtls?.study_case_definition == EVENT_CLASSIFICATION_AESI) || (eventDtls?.study_case_definition == EVENT_CLASSIFICATION_OTHER)) && (
                                                    <div className="reviewaetilte">
                                                        <div className="custm-radio-styl ">
                                                            <label
                                                                htmlFor="notmetcase"
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "start",
                                                                }}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    id="notmetcase"
                                                                    checked
                                                                    style={{ width: "20px" }}
                                                                />
                                                                <span style={{ marginLeft: "10px" }}>
                                                                    <div className="custm-radio-styl">
                                                                        {eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI
                                                                            ? 'Adverse Event of Special Interest'
                                                                            : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER
                                                                                ? 'Other'
                                                                                : ''}
                                                                    </div>
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                )}

                                                {eventDtls?.input_notes_aesi_others !== null &&
                                                    <div>
                                                        <input
                                                            value={notesChange}
                                                            id="Treatment"
                                                            type="text"
                                                            className="border py-3 px-2 rounded w-100"
                                                            onChange={handleNotesChange}
                                                            style={{ marginTop: "12px", padding: "12px", height: "60px" }}
                                                        />
                                                    </div>
                                                }
                                                {eventDtls !== "" ? (
                                                    <div className="advEventGroup">
                                                        <div className="p-4 bg-light rounded eventClassificationDiv">
                                                            {eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? (
                                                                <div className="accordianClass">
                                                                    <BrightonCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset} getEventDescId={getEventDescId} />
                                                                </div>

                                                            ) : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? (
                                                                <Accordion >
                                                                    <GradeCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset} getEventDescId={getEventDescId} />
                                                                </Accordion>
                                                            ) : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ?
                                                                <Accordion >
                                                                    <div className="fs-6" dangerouslySetInnerHTML={{ __html: getStudyAeDtls && getStudyAeDtls[0]?.other_case?.study_aesi_description.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div>
                                                                </Accordion>
                                                                : (
                                                                    ""
                                                                )}
                                                        </div>
                                                    </div>
                                                ) : null}

                                            </div>
                                        </div>
                                    </div>

                                    {eventDtls?.any_treatment_given !== '' && eventDtls?.any_treatment_given !== null &&
                                        <div>
                                            <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                                            <input
                                                value={eventDtls?.any_treatment_given}
                                                className="border py-3 px-2 rounded w-100"
                                                id="Treatment Given"
                                                placeholder="Enter Treatment Given"
                                                disabled="true"
                                            />
                                        </div>
                                    }
                                    
                                        <div>
                                            <label htmlFor="Treatment" className="fw-bold fs-6">Comments</label>
                                            <input
                                                value={treatmentGiven}
                                                className="border py-3 px-2 rounded w-100"
                                                id="Treatment Given"
                                                placeholder="Enter Comments"
                                                onChange={handleTreatment}
                                            />
                                        </div>
                                                      <div>
  {selectedDocument && !['xlsx', 'xls'].includes(extensions) && (
    <Modal show={selectedDocument !== null} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isImage(extensions) ? (
          <img
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc', width: "100%" }}
          />
        ) : (
          <iframe
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc' }}
          />
        )}
      </Modal.Body>
    </Modal>
  )}
</div>

                                </Col>
                            </div>
                            <div className="registrationStepsFooter" >
                                <button className="white_btn white_btn_back px-3" onClick={handleBack}>
                                    Back
                                </button>
                                
                            </div>
                        </Row>
                    </Container>
                </div>
                <PopUpModal
                    handleClose={handleClosePopup}
                    open={open}
                    title={"Success!"}
                    msg={"Adverse event updated successfully!"}
                    close={"Close"}
                    actionbtn={"Done"}
                    onConfirm={handleConfirm}
                />
            </div>
            {loading && <Loader />}
        </>
    );
};
export default ViewAEDetails;